export default __webpack_public_path__ + "static/media/image-homepage-hero.4eb4358b.jpg";